var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slot"},[_c('div',{staticClass:"reel",style:(_vm.reelStyle)},_vm._l((_vm.numbers),function(n){return _c('div',{key:n},[_vm._v("\n      "+_vm._s(_vm.leadingNumber(n))+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }